import React, { Fragment, useContext, useEffect } from 'react';
import { Grid, Button, Paper, Typography } from '@material-ui/core';
import { useStyles } from '../styles/Styles';
import SuccessScheduler from '../components/success/SuccessScheduler';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import Spinner from '../components/spinner/Spinner';
import Header from '../components/header/Header';

const SchedulerAcknowledgement = () => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    applicationDetails,
    noOfUploadedDocs,
    noOfRequiredDocs,
    noOfSubmittedDocs,
    submitDocuments,
    errors,
    nextStep,
    selectedVideoCallSchedule,
    selectedDisplayVideoCallSchedule
  } = documentUploadContext;

  useEffect(() => {

  }, [noOfSubmittedDocs, noOfRequiredDocs]);

  useEffect(() => {
    if (errors === 'error') {
      nextStep(2);
    } 
  }, [errors]);
  return (
    <div>
      <Header page={3} />
      <div className={classes.banner}>
        <Paper elevation={3} className={classes.acknowledgementpaper}>
          {noOfSubmittedDocs >= noOfRequiredDocs ? (
            <Fragment>
              <SuccessScheduler severity={'success'} />
              <Grid container
                    justify='center'
                    alignItems='center'>
                <Grid itemx xs={12} sm={12} md={4} lg={4} xl={4} alignItems='center'>
                  <p className={classes.acknowledgementHeaders}>
                    Reference Number
                  </p>
                  <Typography>
                    {applicationDetails.referenceNumber}
                    <br />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={4} xl={4} alignItems='center'>
                  <p className={classes.acknowledgementHeaders}>
                    Date and Time of Video Call
                  </p>
                  <Typography>
                    {selectedDisplayVideoCallSchedule}
                    <br />
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                justify='center'
                alignItems='center'
              >
                <Grid item md={2}>
                  <Button
                    className={classes.acknowledgementButton}
                    variant='contained'
                    color='primary'
                    href='/'
                  >
                    Back to Home Page
                  </Button>
                </Grid>
              </Grid>
            </Fragment>
          ) : (
            <h1>
              <Spinner />
            </h1>
          )}
        </Paper>
      </div>
    </div>
  );
};

export default SchedulerAcknowledgement;
